var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-part"},[_c('h1',{staticClass:"form-part__title pb-6"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"form-part__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }